// =============================================================
// ProductSwitcher.jsx — the top-bar dropdown that toggles an internal Harvus
// user between the main Capital app and the Lodge Management console.
// Used in both the Harvus header (App.jsx) and the Lodge header.
// SELF-CONTAINED / REMOVABLE (see OUTFITTER_MODULE.md).
// =============================================================

import React, { useState, useRef, useEffect } from 'react';
import { B, font, radius, weight } from '../../../constants/brand';
import { Icon } from '../components/LodgeUI';

const PRODUCTS = [
  { id: 'harvus', label: 'Harvus Capital', icon: 'dashboard', desc: 'Investment management' },
  { id: 'lodge', label: 'Lodge Management', icon: 'calendar', desc: 'Outfitter & lodge booking' },
];

export function ProductSwitcher({ product, onChange, variant = 'default', collapsed = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  const current = PRODUCTS.find((p) => p.id === product) || PRODUCTS[0];
  const dark = variant === 'sidebar';

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen((o) => !o)} title={collapsed ? current.label : undefined} style={collapsed ? {
        display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)',
        borderRadius: radius.lg, padding: '8px 0', cursor: 'pointer', fontFamily: 'inherit', color: B.white,
      } : dark ? {
        display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)',
        borderRadius: radius.lg, padding: '8px 10px', cursor: 'pointer', fontFamily: 'inherit', color: B.white, fontSize: font.sm, fontWeight: weight.semibold,
      } : {
        display: 'inline-flex', alignItems: 'center', gap: 8, background: B.surfaceMuted, border: `1px solid ${B.border}`,
        borderRadius: radius.lg, padding: '6px 10px', cursor: 'pointer', fontFamily: 'inherit', color: B.text, fontSize: font.sm, fontWeight: weight.semibold,
      }}>
        <Icon name={current.icon} size={15} />
        {!collapsed && <span style={dark ? { flex: 1, textAlign: 'left' } : undefined}>{current.label}</span>}
        {!collapsed && <Icon name="chevronDown" size={13} style={{ opacity: 0.7 }} />}
      </button>
      {open && (
        <div style={{
          position: 'absolute', left: 0, minWidth: 240, background: B.surface, border: `1px solid ${B.border}`,
          borderRadius: radius.xl, boxShadow: B.shadowMd, zIndex: 200, overflow: 'hidden', padding: 4,
          ...(dark ? { bottom: '110%' } : { top: '110%' }),
        }}>
          {PRODUCTS.map((p) => {
            const on = p.id === product;
            return (
              <button key={p.id} onClick={() => { setOpen(false); if (p.id !== product) onChange(p.id); }} style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', border: 'none',
                background: on ? B.tealLt : 'transparent', borderRadius: radius.md, padding: '9px 10px', cursor: 'pointer', fontFamily: 'inherit',
              }}
                onMouseEnter={(e) => { if (!on) e.currentTarget.style.background = B.surfaceMuted; }}
                onMouseLeave={(e) => { if (!on) e.currentTarget.style.background = 'transparent'; }}>
                <span style={{ color: B.navy, display: 'flex' }}><Icon name={p.icon} size={17} /></span>
                <span style={{ minWidth: 0 }}>
                  <div style={{ fontSize: font.sm, fontWeight: weight.semibold, color: B.text }}>{p.label}</div>
                  <div style={{ fontSize: font.xs, color: B.textMd }}>{p.desc}</div>
                </span>
                {on && <span style={{ marginLeft: 'auto', color: B.navy }}><Icon name="check" size={15} /></span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
